"use client"

import { createContext } from "react"

type ServerWalletContextType = {
  address: string | undefined
  authenticated: boolean
}

export const ServerWalletContext = createContext<ServerWalletContextType>({
  address: undefined,
  authenticated: false,
})
